import { motion } from "framer-motion";
import Cursor from "../components/CursorBall"


const Exp = () =>{
    
   

    return(
        <div>
            <section className="m-auto ">

                <Cursor/>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff"}}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
                <motion.h1 
                initial={{ opacity: 0, x:-80, rotateX:90, color:"#0000ff" }}
                whileInView={{ opacity: 1, x:0, rotateX:0, color:"#fff" }}
                transition={{ type: "tween",duration: 0.5 }}
                className="px-8 -py-8 text-[3rem] md:text-[10rem] text-white object-contain">Hari Prasad</motion.h1>
            </section>
        </div>
    )
}

export default Exp;